// extracted by mini-css-extract-plugin
export var growableInput = "_5e-0";
export var tagContainer = "_5e-2";
export var textInput = "_5e-1";